<template>
  <section class="star-score">
    <div v-if="pageType === 'single'" class="left title">
      <span class="isRequred" v-if="isRequired">*</span>
      <span v-if="isShowNumber == 1">{{ qNo }}</span>
    </div>
    <div class="right">
      <div class="title" v-if="question.subject_title_type == 1">
        <span class="pure-text">{{
          question.title_quote_title_num !== 0 ? optionsTitle : question.subject
        }}</span>
      </div>
      <div v-else>
        <rich-text
          :type="2"
          :content="
            question.title_quote_title_num !== 0
              ? optionsTitle
              : question.subject
          "
        />
      </div>
      <div class="desc">
        <span>{{ left_desc }}</span>
        <span>{{ right_desc }}</span>
      </div>
      <div class="answer-list">
        <div
          class="list-item"
          v-for="(item, idx) in answerList"
          :key="idx"
          @click.stop="hanleSelect(item, idx)"
        >
          <div :class="['t-item', { checked: item.checked }]"></div>
        </div>
      </div>
      <div
        v-if="inapplicability"
        :class="['no-use']"
        @click.stop="hanleSelect()"
      >
        <span :class="[{ checked: checkNoUse }]">{{ inapplicability }}</span>
      </div>
    </div>
  </section>
</template>

<script>
/**
 * 判断题组件
 */
import RichText from '@/components/rich-text';

export default {
  name: 'ScoreStar',
  components: { RichText },
  props: {
    isShowNumber: {
      //是否显示序号
      type: Number,
      default: 0,
    },
    pageType: {
      type: String,
      default: 'single', // 默认单页展示
    },
    isRequired: {
      type: Boolean,
      default: true,
    },
    index: {
      type: Number,
      default: 0,
    },
    titleNo: {
      type: Number, // 当前题目序号
      default: 0,
    },
    question: {
      type: Object,
      default: () => {},
    },
    answer_json: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      qNo: this.titleNo < 9 ? `0${this.titleNo}` : this.titleNo, // 问题序号

      answerList: [],
      left_desc: '', // 左侧描述
      right_desc: '', // 右侧描述
      inapplicability: '', // 不适应性描述
      checkNoUse: false,
    };
  },
  mounted() {
    this.left_desc = this.question?.option?.left_desc?.option || '';
    this.right_desc = this.question?.option?.right_desc?.option || '';
    this.inapplicability = this.question?.option?.inapplicability?.option || '';
    let scale = this.question?.option?.scale || 5;

    // 稀疏数组不会调用map方法
    const arr = new Array(scale)
      .fill()
      .map((item, index) => ({ option_key: index + 1, checked: false }));
    this.answerList = arr;
  },
  methods: {
    hanleSelect(item, idx) {
      for (const item of this.answerList) {
        item.checked = false;
      }
      let answer = '';
      if (!item && !idx) {
        // 选中不适应性
        this.checkNoUse = true;
        answer = 'inapplicability';
      } else {
        // 选中普通打分
        this.checkNoUse = false;
        this.answerList = this.answerList.map((item, dx) => {
          if (dx <= idx) {
            item.checked = true;
          } else {
            item.checked = false;
          }
          return item;
        });
        answer = item.option_key;
      }
      this.$emit('change', answer, this.index, this.question);
    },
  },
  computed: {
    // 标题引用前题选项
    optionsTitle() {
      const preQuestion =
        this.answer_json[this.question.title_quote_title_num - 1];
      if (this.question.title_quote_title_num !== 0 && preQuestion) {
        let optionsNames = '';
        // 判断题 量表题 打分题取同层的 option_name
        if ([3, 4, 5].includes(preQuestion.subject_type)) {
          optionsNames = preQuestion.option;
          if (preQuestion.subject_type === 3) {
            optionsNames = preQuestion.option_name || '';
          }
        } else {
          optionsNames = preQuestion.option
            .map((item) => item.option_name)
            .join(' ');
        }
        return this.question.subject.replace(/【.*?】/, optionsNames);
        // return '【】'
      } else {
        return this.question.subject.replace(/【.*?】/, '');
      }
    },
  },
};
</script>

<style lang="less" scoped>
.star-score {
  display: flex;
  .isRequred {
    color: #ff3b30;
    font-size: 18px;
  }
  .title {
    font-size: 16px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
    line-height: 25px;
  }
  .left {
    width: 30px;
    margin-right: 8px;
    text-align: right;
  }
  .right {
    flex: 1;
    .desc {
      display: flex;
      justify-content: space-between;
      color: rgba(0, 0, 0, 0.45);
      font-size: 12px;
      margin-bottom: 8px;
      margin-top: 20px;
    }
    .answer-list {
      display: flex;
      justify-content: space-between;
      .t-item {
        width: 34px;
        height: 32px;
        background-image: url('~@/assets/images/question/star2.png');
        background-size: 100% auto;
        background-repeat: no-repeat;
        &.checked {
          background-image: url('~@/assets/images/question/star1.png');
        }
      }
    }
    .no-use {
      margin-top: 26px;
      text-align: center;
      span {
        font-size: 14px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.85);
        padding: 7px 10px;
        border: 1px solid rgba(0, 0, 0, 0.09);
        border-radius: 30px;
        &.checked {
          background: rgba(255, 102, 0, 0.08);
          color: #ff6600;
          border: 1px solid #ff6600;
        }
      }
    }
  }
}
</style>
